export default __webpack_public_path__ + "static/media/logo_parking.d6cd2ec1.svg";